import { render, staticRenderFns } from "./MyNoteAdd.vue?vue&type=template&id=3e1acfe2&"
import script from "./MyNoteAdd.vue?vue&type=script&lang=js&"
export * from "./MyNoteAdd.vue?vue&type=script&lang=js&"
import style0 from "./MyNoteAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports